import React from 'react';
import useProjects from '../../../Hooks/useProjects';
import Loading from '../../Shared/Loading';
import Project from '../Project/Project';

const Projects = () => {
    const [projects] = useProjects();
    if(!projects.length){
        <Loading />
    }
    console.log(projects);
    return (
        <div>
            <div className='w-100'>
                <h2 className='pb-4 pt-12 text-2xl text-center mt-16  text-secondary font-bold'>Trending Projects</h2>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-9 gap-y-14 lg:px-24 px-8 pt-8 pb-24'>
                {
                    projects?.map(project => <Project
                        key={project?.id}
                        project={project}
                    ></Project>)
                }
            </div>
        </div>
    );
};

export default Projects;